import './../RedemptionForm.css';


const CouponForm = ({ code, loading, error, onChange, onSubmit }) => (
  <form onSubmit={onSubmit} className="form-layout-coupon">
    <label htmlFor="coupon" className="form-label">Enter Redemption Code:</label>
    <input
      type="text"
      id="coupon"
      value={code}
      onChange={onChange}
      className="form-input"
      placeholder="XXXX"
    />
    <button type="submit" className="form-button" disabled={loading}>
      {loading ? 'Checking...' : 'Submit'}
    </button>
    {error && <p className="form-error">{error}</p>}
  </form>
);

export default CouponForm;
